import { render, staticRenderFns } from "./giftCard_list.vue?vue&type=template&id=28a4cc2d&scoped=true&"
import script from "./giftCard_list.vue?vue&type=script&lang=js&"
export * from "./giftCard_list.vue?vue&type=script&lang=js&"
import style0 from "./giftCard_list.vue?vue&type=style&index=0&id=28a4cc2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a4cc2d",
  null
  
)

export default component.exports